import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=7327f2dd&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=7327f2dd&prod&lang=scss"
import style2 from "./Sidebar.vue?vue&type=style&index=2&id=7327f2dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7327f2dd",
  null
  
)

export default component.exports